// Single source of truth for marketing-site SEO and AI-discovery metadata.
// Consumed by the <Seo> component, the static llms.txt, the sitemap generator,
// and the JSON-LD Organization schema.

export type Locale = 'es' | 'en';

export const SUPPORTED_LOCALES: Locale[] = ['es', 'en'];
export const DEFAULT_LOCALE: Locale = 'es';

export const SITE_URL = 'https://callcov.com';
export const ORG_NAME = 'CallCov';
export const ORG_LEGAL_NAME = 'CallCov';
export const ORG_LOGO_URL = `${SITE_URL}/logo512.png`;
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og/callcov-default.png`;
export const CONTACT_EMAIL = 'ventas@callcov.com';
export const TWITTER_HANDLE = '@callcov';

export const SOCIAL_PROFILES: string[] = [
  'https://www.linkedin.com/company/callcov',
];

// All public marketing routes that should be indexable, prerenderable, and
// listed in the sitemap. Route paths exclude any locale prefix; the locale is
// applied at render/build time once URL-based i18n lands.
export const PUBLIC_ROUTES = [
  '/',
  '/compliance',
  '/quality',
  '/pricing',
  '/about',
  '/contact',
  '/support',
  '/terms',
  '/privacy',
] as const;

export type PublicRoute = (typeof PUBLIC_ROUTES)[number];

// Routes that must NEVER appear in the sitemap or be indexed by search/AI
// crawlers. Authenticated app routes plus transactional auth flows.
export const NON_INDEXABLE_ROUTES = [
  '/dashboard',
  '/account-settings',
  '/api-keys',
  '/billing',
  '/analyses',
  '/uploads',
  '/signin',
  '/signup',
  '/verify-email',
  '/reset-password',
  '/reset-password-confirmation',
] as const;
